import React, { HTMLAttributes } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';

interface WrapperProps extends HTMLAttributes<HTMLDivElement> {
  show?: boolean;
  close: () => void;
  children: React.ReactNode;
  disableBackdropClick?: boolean;
}

export default function ModalWrapper({
  show = false,
  close,
  children,
  disableBackdropClick,
  ...rest
}: WrapperProps) {
  const { className } = rest;
  return (
    <>
      <Transition appear show={show} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-100 overflow-y-auto"
          onClose={disableBackdropClick ? () => {} : close}
        >
          <Dialog.Overlay className="fixed inset-0 bg-black !bg-opacity-50" />
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                className={`inline-block transform overflow-hidden align-middle bg-white p-6 shadow-xl rounded-lg ${className}`}
                {...rest}
              >
                {children}
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

ModalWrapper.propTypes = {
  show: PropTypes.bool,
  close: PropTypes.func,
  children: PropTypes.object,
  disableBackdropClick: PropTypes.bool,
};
